import axios from 'axios'
import user from './user'
import FileSaver from "file-saver";
import {handleError} from "../../common"

const state = {
    terminalTypes: [],
    customers: [],
    terminals: [],
    subscriptions: [],
    loadMoreTerminals: true
};

const mutations = {
    setTerminals (state, terminals) {
        state.terminals = terminals;
    },
    appendTerminals (state, terminals) {
        state.terminals =  state.terminals.concat(terminals);
    },
    deleteTerminal(state, id){
        state.terminals = state.terminals.filter(obj => {
            return obj.id !== id
        });
    },
    reset(state) {
        state.terminals = [];
        state.loadMoreTerminals = true;
    },
    setLoad(state, load) {
        state.loadMoreTerminals = load;
    },
    setTypes(state, types) {
        state.terminalTypes = types;
    },
    setCustomers(state, customers) {
        state.customers = customers;
    },
    setSubscriptions(state, subscriptions) {
        state.subscriptions = subscriptions;
    },
};

const getters = {

};

const actions = {

    loadOptions({commit}, params = {}) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/terminal/options', config)
                .then((response) => {
                    if (response.data.success) {
                        commit('setTypes', response.data.types);
                        commit('setCustomers', response.data.customers);
                        commit('setSubscriptions', response.data.subscriptions);
                        resolve();
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },
    loadTerminals({commit}, params = {}) {
        if (params.page === undefined) {
            params.page = 0
        }
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/terminals', config)
                .then((response) => {
                    if (response.data.success) {
                        params.page ? commit('appendTerminals', response.data.terminals, true) : commit('setTerminals', response.data.terminals);
                        if (response.data.currentPage + 1 >= response.data.pages ) {
                            commit('setLoad', false);
                        }

                        resolve();
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },
    deleteTerminal({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/terminal/delete', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Terminal deleted",
                            type: "success",
                        } , { root: true });
                        commit('deleteTerminal', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    addTerminal({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/terminal/create', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Terminal added",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    updateTerminal({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/terminal/update', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Terminal updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    exportTerminals({commit}, fileName) {
        let config = {
            responseType: 'arraybuffer' ,
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/terminal/export', config)
                .then((response) => {
                    if (response.data) {
                        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                        FileSaver.saveAs(blob, fileName);
                        resolve();
                    } else {
                        /*commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });*/
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    }


};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
